import React, { Component } from 'react';
import Formatter from '../../utils/Formatter';
import { IconButton, Tooltip } from '@mui/material';
import Delete from '@mui/icons-material/Delete';
import Preview from '@mui/icons-material/FindInPage';
import CloudDownload from '@mui/icons-material/CloudDownload';
import CheckCircle from '@mui/icons-material/CheckCircle';
import ChangeCircleIcon from '@mui/icons-material/ChangeCircle';
import Cancel from '@mui/icons-material/Cancel';
import AttachFile from '@mui/icons-material/AttachFile';
import VoidFormReason from '../VoidFormReason';
import SettingsBackRestore from '@mui/icons-material/SettingsBackupRestore';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import CircularProgress from '@mui/material/CircularProgress';
import { connect } from 'react-redux';
import { showError, showMessage, confirmAction } from '../../actions/uiActions';
import FormsApi from '../../api/forms';
import Chip from '@mui/material/Chip';
import IconButtonFileUploader from '../IconButtonFileUploader';
import AddForm from '../../forms/AddForm';
import Auth from '../../api/auth';
import AccountsApi from '../../api/accounts';
import UsersApi from '../../api/users';
import ServicerAddress from '../../forms/ServicerAddress';
import AnalysisTools from '../../utils/AnalysisTools';
import moment from 'moment';
import PSLFDestinatary from '../PSLFDestinatary';
import { Menu, MenuItem } from '@mui/material';
import { getSignatureRequestError } from '../../utils/FormsTools';
import GenericFormPreview from '../DynamicForms/GenericFormPreview';
import PrintIcon from '@mui/icons-material/Print';
import Servicer from '../../forms/Servicer';
import { updateServicer } from '../../actions/dataActions';
import PSLFEmployerDetails from '../PSLFEmployerDetails';
import AssignServicer from '../../forms/AddForm/AssignServicer';
import EditCustomFormTitle from './EditCustomFormTitle';
import { Edit } from '@mui/icons-material';
import ApproveFormModal from './ApproveFormModal';
import { ACTIVE_MEMBERSHIP } from '../../utils/constants';
import { DCL_FORM_ID, IDR_FORM_ID, RPR_FORM_ID, TLF_FORM_ID } from '../../constant/formIds';
import PreviewProofFile from '../DynamicForms/PreviewProofFile';
class Forms extends Component
{
  state = {
    uploadingSignedForm: null,
    downloadingSignedForm: null,
    mode: '',
    deleting: null,
    reassigning: null,
    form: null,
    approving: false,
    employment: false,
    void: false,
    anchorEl: null,
    faxAnchorEl: null,
    editServicer: null,
    showAssignServicer: false,
    editForm: null,
    showFormActionModal: false,
    formActionStatus: '',
  };
  _proceedToDelete = (form, reason = '') =>
  {
    this.setState({ deleting: form, void: false }, () =>
      FormsApi.deleteForm(this.props.id, form.id, reason)
        .then(success =>
        {
          this.setState({ deleting: null });
          const forms = this.props.account.forms.filter(existingForm => existingForm.id != form.id);
          this.props.updateAccount({
            forms,
          });
          if (form.requested > 0 || form.completed || form.envelopeId || form.file)
          {
            const voidedForms = (this.props.account.voidedForms || []).push({
              ...form,
              reason,
              date: moment().format('X')
            })
            this.props.updateAccount({
              voidedForms
            });
          }
          this.props.showMessage('The form has been deleted.');
        })
        .catch(error =>
          this.setState({ form: null, deleting: false }, this.props.showError)
        )
    );
  };
  delete = form =>
  {
    this.props.confirmAction(
      "You are going to delete this form from the borrower's required forms, therefore the borrower will no longer be required to fill this form. Do you want to continue?",
      () =>
      {
        if ((form.requested && form.completed && form.envelopeId) || form.file)
        {
          this.setState({ form, void: true });
        } else
        {
          this._proceedToDelete(form);
        }
        /*else
                this.props.confirmAction("This form has been already filled by the user, therefore deleting it you will require the user to fill and sign the form again and the previous filled form will be lost. Do you confirm that you want to delete a form that has been already completed by the user?",()=>this._proceedToDelete(form),"Confirm deletion of completed form","Confirm","Cancel",null,true);*/
      }
    );
  };

  reassign = async (form) =>
  {
    this.props.confirmAction(
      "You are going to delete this form from the borrower's required forms and reassign to the borrower. Do you want to continue?",
      async () =>
      {
        try
        {
          this.setState({ reassigning: form.form })
          await FormsApi.reAssignForm(this.props.id, form.id)
          this.props.showMessage('The form has been reassigned.');
          const forms = this.props.account.forms.filter(existingForm => existingForm.id != form.id);
          this.props.updateAccount({
            forms,
          });
        } catch (error)
        {
          this.props.showError(error)
        } finally
        {
          this.setState({ reassigning: null })
        }
      }
    );
  };
  authorize = (byPass = false) =>
  {
    if (Auth.account.role == 'sales')
      this.props.showError('You are not authorized to do this.');
    else if (
      !byPass &&
      AnalysisTools.strategyRecommendsSameIDR(this.props.account) &&
      this.props.account.forms.find(f => f.form == 0)
    )
    {
      this.props.confirmAction(
        "You are going to assign the Income Driven Repayment Plan request to this user, and since some of the user's loans are already being repaid under the same IDR plan, it may imply an increase in the monthly payment. Please confirm that you want to assign the Income Driven Repayment Plan request form to the user.",
        () => this.authorize(true),
        null,
        null,
        null,
        null,
        true
      );
    } else
    {
      const message = "You are going to approve the required forms for this user, therefore the user will receive an email with the strategy found by Ed, and instructions to activate the account. Do you want to proceed?"
      return this.props.confirmAction(message, () => this.approveForm(), "", "Approve and activate", "Cancel", null)
    }
  };
  componentDidMount()
  {
    window.scrollTo(0, 0);
    this.showPSLFEmployerSelection();
  }

  async approveForm()
  {
    try
    {
      this.setState({ approving: true });
      await UsersApi.activate(this.props.id);
      this.props.updateAccount({
        membership: ACTIVE_MEMBERSHIP,
      });
      this.setState({ approving: false });
      this.props.showMessage('The required forms have been approved and an email has been sent to the user.');
      this.props.onApprove();
    } catch (error)
    {
      this.setState({ approving: false });
      this.props.showError(error);
    }
  }
  showPSLFEmployerSelection()
  {
    if (!this.props.analysis || !this.props.analysis.approved)
    {
      return;
    }
    const pslfForms = this.props.forms.filter(
      form =>
        !form.live &&
        (form.form == 3 || form.form == 2) &&
        !form.employer &&
        AnalysisTools.canSubmit(form) &&
        /^[0-9]+$/.test(form.form)
    );
    if (pslfForms.length)
    {
      this.setState({ employment: true, form: pslfForms[0] });
    }
  }
  triggerFaxSend = async (faxWithTax = false) =>
  {
    try
    {
      await FormsApi.faxLive(this.props.id, this.state.form.id, faxWithTax);
      this.setState({ submitting: false });
      this.props.showMessage('The form has been sent to the servicer.');
      this.props.onFormSubmitted(this.state.form, true);
    } catch (error)
    {
      this.setState({ submitting: false });
      this.props.showError(error);
    }
  }
  submitFormFax = () =>
  {
    this.validateCompletedFormOnSubmit();
    const selectedForms = [IDR_FORM_ID, DCL_FORM_ID, RPR_FORM_ID]
    if (selectedForms.includes(Number(this.state.form.form)))
    {
      this.setState({ showAssignServicer: true })
      return
    }
    this.setState({ submitting: true, faxAnchorEl: null });
    this.props.confirmAction(
      'CAUTION: You are going to FAX the form to the servicer, before FAXing the form you must carefully review that all the information is correct and accurate, also you must double check to make sure the information in the form matches the one provided by the user and used in the analysis. Please confirm that you have reviewed the information and the form is correct and accurate. By confirming, the form will be sent to the servicer.',
      () => this.triggerFaxSend(), "Confirm action", "Yes", "No", () => this.setState({ submitting: false })
    );
  };

  submitFormForFaxing = async (faxWithTax) =>
  {
    this.setState({ submitting: true, faxAnchorEl: null });
    try
    {
      this.triggerFaxSend(faxWithTax)
    } catch (error)
    {
      this.setState({ submitting: false });
      this.props.showError(error);
    }

  }

  validateCompletedFormOnSubmit = () =>
  {
    let currentForm = this.props.account.forms.find(form => form.id === this.state.form.childFormId)

    if (
      this.state.form.form === 0 &&
      !this.props.account.forms.find(
        form =>
          (form.form === 5 || form.form === 9 || form.form === 10) &&
          form.completed
      )
    )
    {
      this.props.showError(
        'An Income Driven Repayment Plan request must include a proof of income, either Last Year Tax returns, last 2 pay stubs, or letter to verify income.'
      );
      return;
    }
    if (
      !AnalysisTools.isReadyToSubmit(
        this.state.form.form,
        this.props.account.forms
      ).ready
    )
    {
      this.props.showError(
        AnalysisTools.isReadyToSubmit(
          this.state.form.form,
          this.props.account.forms
        ).message
      );
      return;
    } else if (
      !this.props.account.address ||
      !this.props.account.address.address1 ||
      !this.props.account.address.city ||
      !this.props.account.address.state ||
      !this.props.account.address.zip
    )
    {
      this.props.showError(
        'In order to submit this form, the user must have an address registered.'
      );
      return;
    }
    else if (currentForm && currentForm.parentFormId && !currentForm.completed)
    {
      this.props.showError(
        "This form requires a supporting document(s) to be submitted"
      );
      return;
    }
  }

  markFaxForm = () =>
  {
    this.props.confirmAction(
      `You are going to mark this form as "Sent to Servicer" without sending it through Fax. This will effectively mark this form as completed, and both the system and the user will assume it has been properly completed and submitted to the servicer. Do you want to proceed?`,
      () =>
        this.setState({ submitting: true, faxAnchorEl: null }, () =>
          FormsApi.mark(this.props.id, this.state.form.id)
            .then(
              success =>
              {
                this.setState({ submitting: false });
                this.props.showMessage(
                  `The form has been marked as "Sent to Servicer" and it is considered as "Completed"`
                );
                this.props.onFormSubmitted(this.state.form, true);
              },
              error =>
                this.setState({ submitting: false }, this.props.showError)
            )
            .catch(error =>
              this.setState({ submitting: false }, this.props.showError)
            )
        )
    );
  };
  update = async (formId, status, isEmployerCurrent) =>
  {
    this.setState({ updating: true })
    const success = await FormsApi.update(this.props.id, formId, status, isEmployerCurrent)
    this.setState({ updating: false })
    if (success)
    {
      this.props.showMessage('The form status has been updated successfully.');
      this.props.onFormStatus(formId, status);
      this.setState({ showFormActionModal: false })
    } else
    {
      this.props.showError()
    }
  };

  isFormPSLFForm = (formId) => formId == 2 || formId == 3;

  isClientPSLFForm = (form) =>
  {
    if (this.isFormPSLFForm(Number(form.form)) && form.isThirdPartyFirstSigner)
    {
      return true
    }
    return false;
  }

  isAwaitingEmployer = (form) =>
  {
    if (this.isClientPSLFForm(form) && form.requested && !form.completed)
    {
      return true;
    } else if (!this.isClientPSLFForm(form) && form.signed_by_first_party && !form.completed)
    {
      return true;
    }
    return false;
  }

  getFormExpiredStatus = (form) =>
  {
    if (!form.sentToRightSignatureOn) return false
    const twoMonthsAgo = moment().subtract(2, 'months');
    const sentToRightSignatureOn = moment(form.sentToRightSignatureOn, "X")
    return sentToRightSignatureOn.isBefore(twoMonthsAgo)
  }

  getFormStatus = form =>
  {
    let label;
    let color = "default";
    const twoMonthsAgo = moment().subtract(2, 'months');

    const signed_date = moment(form.signed_date, "X");
    const requested_date = moment(form.requested, "x");
    const assigned_date = moment(form.assigned, "X");
    const sentToRightSignatureOn = moment(form.sentToRightSignatureOn, "X");
    const date_submited = moment(form.date_submited, "X");
    const date_approved_or_rejected = moment(form.date_approved_or_rejected, "X").format('MM/DD/YYYY');
    const isEmploymentCertification = form.form === 2 || form.form === 3;
    if (this.isClientPSLFForm(form) && form.signed_by_first_party && !form.completed)
    {
      label = `Awaiting borrower, employer signed on ${signed_date.format('MM/DD/YYYY')}`;
      color = signed_date.isBefore(twoMonthsAgo) ? 'error' : 'default';
    } else if (this.isAwaitingEmployer(form))
    {
      label = `Awaiting employer, sent on ${requested_date.format('MM/DD/YYYY')}`;
      color = requested_date.isBefore(twoMonthsAgo) ? 'error' : 'default';
    } else if (!this.isFormPSLFForm(form.form) && form.signed_date && !form.completed)
    {
      label = `Awaiting second party, sent on ${signed_date.format('MM/DD/YYYY')}`;
      color = signed_date.isBefore(twoMonthsAgo) ? 'error' : 'default';
    } else if (!form.completed)
    {
      label = isEmploymentCertification && sentToRightSignatureOn.isBefore(twoMonthsAgo) ? 'Expired' : `Awaiting borrower, assigned on ${assigned_date.format('MM/DD/YYYY')}`;
      color = isEmploymentCertification && sentToRightSignatureOn.isBefore(twoMonthsAgo) ? 'error' : 'default';

    } else if (form.completed && !form.live)
    {
      label = `Awaiting submission, completed on ${signed_date.format('MM/DD/YYYY')}`;
      color = signed_date.isBefore(twoMonthsAgo) ? 'error' : 'primary';
    } else if (form.live && !form.status)
    {
      label = `Submitted to servicer on ${date_submited.format('MM/DD/YYYY')}`;
    } else if (form.live && form.status === 'approved')
    {
      label = `Approved on ${date_approved_or_rejected.format('MM/DD/YYYY')}`;
    } else if (form.live && form.status === 'rejected')
    {
      label = `Rejected on ${date_approved_or_rejected.format('MM/DD/YYYY')}`;
    }
    return <Chip label={label} color={color} />;
  };
  showFormMenu = (e, form) =>
  {
    this.setState({ form, anchorEl: e.currentTarget });
  };
  closeFormMenu = form =>
  {
    this.setState({ form: null, anchorEl: null });
  };
  showFaxFormMenu = (e, form) =>
  {
    this.setState({ form, faxAnchorEl: e.currentTarget });
  };
  closeFaxFormMenu = form =>
  {
    this.setState({ form: null, faxAnchorEl: null });
  };

  getCustomFormName = (form) =>
  {
    if (form.form === "5ea6da777f41977661959e9c")
    {
      return form.documentName || this.props.customForms.find(f => f.id === form.form).name;
    } else
    {
      return this.props.customForms.find(f => f.id === form.form).name
    }
  }

  canRenderEmployerDetails = (form) =>
  {
    return ([2, 3].includes(Number(form.form)) ||
      form.form === TLF_FORM_ID) && form?.employer
  }

  renderFormName = form =>
  {
    let parentName = this.props.customForms.find(f => f.id === form.parentFormId)
    return (
      <div>
        {!/^[0-9]+$/.test(form.form) &&
          this.props.customForms.find(f => f.id === form.form)
          ? this.getCustomFormName(form)
          : Formatter.getGovernmentFormName(
            form.form,
            form.recertification
          )} {parentName && parentName.name}
        <div className="form-notes">
          {form.notes}
          {this.canRenderEmployerDetails(form) && (
            <PSLFEmployerDetails employer={form.employer} canOpen={form.employer} />
          )}
        </div>
      </div>
    );
  };
  canUserBeActivated = () =>
  {
    return this.props.account.membership !== ACTIVE_MEMBERSHIP
  }
  canFormsBeAssignedToUser = () =>
  {
    return this.props.account.membership === ACTIVE_MEMBERSHIP
  }
  renderFormsGroup = (forms, emptyMessage = 'There are no pending forms.') =>
  {
    if (forms.length === 0)
    {
      return (
        <TableRow>
          <TableCell colSpan={4} className="text-center">
            {emptyMessage}
          </TableCell>
        </TableRow>
      );
    } else
    {
      return forms.map((form, index) => (
        <TableRow>
          <TableCell>{this.renderFormName(form)}</TableCell>
          <TableCell>
            {!AnalysisTools.hasDefaultServicer(form.form) && form.servicer
              ? Formatter.getServicerFromId(form.servicer, this.props.myStudentData, this.props.servicers)
              : Formatter.getDefaultServicerForForm(form.form)}
          </TableCell>
          <TableCell>{this.getFormStatus(form)}</TableCell>
          <TableCell>
            {this.props.account.membership > 0 &&
              form.completed &&
              form.submitted &&
              !form.live &&
              AnalysisTools.canSubmit(form) && (
                <Tooltip title="Fax Form">
                  <IconButton
                    disabled={
                      this.state.submitting && this.state.form.id === form.id
                    }
                    onClick={() =>
                      this.setState(
                        { form },
                        this.submitFormFax
                      )
                    }
                  >
                    {(!this.state.submitting ||
                      this.state.form.id !== form.id) && <PrintIcon />}
                    {this.state.submitting &&
                      this.state.form.id === form.id && (
                        <CircularProgress size={20} />
                      )}
                  </IconButton>
                </Tooltip>
              )}
            {this.props.account.membership > 0 &&
              form.completed &&
              !form.submitted &&
              AnalysisTools.canSubmit(form) && (
                <Tooltip title="Fax form">
                  <IconButton
                    disabled={
                      this.state.submitting && this.state.form.id === form.id
                    }
                    onClick={e => this.showFaxFormMenu(e, form)}
                  >
                    {(!this.state.submitting ||
                      this.state.form.id !== form.id) && <PrintIcon />}
                    {this.state.submitting &&
                      this.state.form.id === form.id && (
                        <CircularProgress size={20} />
                      )}
                  </IconButton>
                </Tooltip>
              )}
            {this.props.account.membership > 0 &&
              !form.live && !this.getFormExpiredStatus(form) && (
                <IconButtonFileUploader
                  accept=".pdf"
                  onError={this.props.showError}
                  name="file"
                  disabled={
                    this.state.uploadingSignedForm &&
                    this.state.uploadingSignedForm.form == form.form &&
                    this.state.uploadingSignedForm.servicer == form.servicer
                  }
                  onUpload={async (formData) =>
                  {
                    try
                    {
                      this.setState({ uploadingSignedForm: form });
                      await FormsApi.uploadSignedForm(this.props.id, form.id, formData)
                      this.props.onFormCompleted(form, form.servicer);
                      this.props.showMessage('The form has been uploaded successfully.');
                    } catch (error)
                    {
                      this.props.showMessage(error);
                    } finally
                    {
                      this.setState({ uploadingSignedForm: null });
                    }
                  }}
                  label="Upload Filled Form"
                >
                  <AttachFile />
                </IconButtonFileUploader>
              )}
            {this.props.account.membership > 0 &&
              form.submitted &&
              form.live &&
              !form.status && [
                <Tooltip title="Mark as Approved">
                  <IconButton
                    disabled={
                      this.state.updating && this.state.form.id === form.id
                    }
                    onClick={() => this.setState({ showFormActionModal: true, formActionStatus: 'approved', form })}
                  >
                    {(!this.state.updating ||
                      !this.state.form.id !== form.id) && <CheckCircle />}
                    {this.state.updating && this.state.form.id === form.id && (
                      <CircularProgress size={20} />
                    )}
                  </IconButton>
                </Tooltip>,
                <Tooltip title="Mark as Rejected">
                  <IconButton
                    disabled={
                      this.state.updating && this.state.form.id === form.id
                    }
                    onClick={() => this.setState({ showFormActionModal: true, formActionStatus: 'rejected' })}
                  >
                    {(!this.state.updating ||
                      !this.state.form.id !== form.id) && <Cancel />}
                  </IconButton>
                </Tooltip>
              ]}

            {form.completed && (
              <>
                <Tooltip title="Preview Form">
                  <IconButton
                    onClick={() =>
                      this.setState({
                        previewForm: {
                          formId: form.id,
                          form: form.form,
                          fileName: form.file
                        }
                      })
                    }
                  >
                    <Preview />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Download Filled Form">
                  <IconButton
                    disabled={
                      this.state.downloadingSignedForm &&
                      this.state.downloadingSignedForm.form == form.form &&
                      this.state.downloadingSignedForm.servicer == form.servicer
                    }
                    onClick={() =>
                      this.setState({ downloadingSignedForm: form }, () =>
                        FormsApi.downloadSignedForm(
                          this.props.id,
                          form.id,
                          form.form,
                          form.file
                        )
                          .then(
                            success =>
                              this.setState({
                                downloadingSignedForm: null
                              }),
                            error =>
                              this.setState(
                                {
                                  downloadingSignedForm: null
                                },
                                this.props.showError
                              )
                          )
                          .catch(error =>
                            this.setState(
                              { downloadingSignedForm: null },
                              this.props.showError
                            )
                          )
                      )
                    }
                  >
                    {(!this.state.downloadingSignedForm ||
                      !this.state.downloadingSignedForm.form == form.form ||
                      !this.state.downloadingSignedForm.servicer ==
                      form.servicer) && <CloudDownload />}
                    {this.state.downloadingSignedForm &&
                      this.state.downloadingSignedForm.form == form.form &&
                      this.state.downloadingSignedForm.servicer ==
                      form.servicer && <CircularProgress size={20} />}
                  </IconButton>
                </Tooltip>
              </>
            )}
            {/*form.autofill&&<Tooltip title="Fill Form">
                    <IconButton>
                        <Assignment />
                    </IconButton>
            </Tooltip>*/}

            <Tooltip title="Delete Required Form">
              <IconButton
                disabled={
                  this.state.deleting &&
                  this.state.deleting.form == form.form &&
                  this.state.deleting.servicer == form.servicer
                }
                onClick={() => this.delete(form)}
              >
                {(!this.state.deleting ||
                  !this.state.deleting.form == form.form ||
                  !this.state.deleting.servicer == form.servicer) && (
                    <Delete />
                  )}
                {this.state.deleting &&
                  this.state.deleting.form == form.form &&
                  this.state.deleting.servicer == form.servicer && (
                    <CircularProgress size={20} />
                  )}
              </IconButton>
            </Tooltip>

            {this.getFormExpiredStatus(form) && <Tooltip title="Reassign Form">
              <IconButton
                disabled={
                  this.state.reassigning &&
                  this.state.reassigning.form == form.form
                }
                onClick={() => this.reassign(form)}
              >
                {(!this.state.reassigning ||
                  this.state.reassigning.form != form.form) && (
                    <ChangeCircleIcon />
                  )}
                {this.state.reassigning &&
                  this.state.reassigning.form == form.form && (
                    <CircularProgress size={20} />
                  )}
              </IconButton>
            </Tooltip>}
          </TableCell>
        </TableRow>
      ));
    }
  };

  isFormApprovedOrRejected = (form, status) => this.props.account.membership > 0 &&
    form.submitted && form.live && form.status === status;

  formStatusButtonAction = (form) =>
  {
    let components = []
    if (!form.status || this.isFormApprovedOrRejected(form, 'rejected'))
    {
      components.push(<Tooltip title="Mark as Approved">
        <IconButton
          disabled={
            this.state.updating &&
            this.state.form.id == form.id
          }
          onClick={() =>
            this.setState({ showFormActionModal: true, formActionStatus: 'approved', form })
          }
        >
          {(!this.state.updating ||
            !this.state.form.id != form.id) && (
              <CheckCircle />
            )}
          {this.state.updating &&
            this.state.form.id == form.id && (
              <CircularProgress size={20} />
            )}
        </IconButton>
      </Tooltip>)
    }
    if (!form.status || this.isFormApprovedOrRejected(form, 'approved'))
    {
      components.push(
        <Tooltip title="Mark as Rejected">
          <IconButton
            disabled={
              this.state.updating &&
              this.state.form.id == form.id
            }
            onClick={() =>
              this.setState({ showFormActionModal: true, formActionStatus: 'rejected', form })
            }
          >
            {(!this.state.updating ||
              !this.state.form.id != form.id) && (
                <Cancel />
              )}
          </IconButton>
        </Tooltip>
      );
    }
    return components;
  };

  determinePreviewModal = (form) =>
  {
    if (!(form || {}).files && form.file)
    {
      this.setState({ previewForm: { formId: form.id, form: form.form, fileName: form.file } })
      return
    }
    this.setState({ previewForm: { formId: form.id, form: form.form, fileName: form.files[0], files: form.files, assigned: form.assigned, type: form.type } })
  }

  render()
  {
    if (this.state.editServicer)
    {
      return (
        <Servicer
          mode={this.state.editServicer ? 'edit' : ''}
          onUpdated={servicer =>
          {
            this.props.updateServicer(servicer);
            this.setState({
              editServicer: null
            });
          }}
          onCancel={() => this.setState({ editServicer: null })}
          servicer={this.state.editServicer}
        />
      );
    }
    if (!this.props.myStudentData)
    {
      return (
        <div className='row' style={{ paddingBottom: "20px" }}>
          <div className='col-12 text-center'>
            No MSD found, pls update your MSD to view Forms
          </div>
        </div>
      );
    }
    if (this.state.editForm)
    {
      return (
        <EditCustomFormTitle
          onClose={() => this.setState({ editForm: null })}
          editForm={this.state.editForm}
        />
      )
    }
    return this.props.account.loanType !== 'private' ? (
      <div className="animated fadeIn padding">
        {this.state.previewForm && (
          <GenericFormPreview
            form={this.state.previewForm}
            user={this.props.id}
            onClose={() => this.setState({ previewForm: null })}
          />
        )}
        {this.state.loanProof && (
          <PreviewProofFile
            loanProof={this.state.loanProof}
            userId={this.props.id}
            onClose={() => this.setState({ loanProof: null })}
          />
        )}
        {this.state.showAssignServicer && (
          <AssignServicer
            forms={this.props.forms}
            userId={this.props.id}
            form={this.state.form}
            onServicerAssigned={this.submitFormForFaxing}
            onFormSubmitted={() => this.props.onFormSubmitted(this.state.form, true)}
            account={this.props.account}
            onCancel={() => this.setState({ showAssignServicer: false, faxAnchorEl: null })}
            myStudentData={this.props.myStudentData}
          />
        )
        }
        {!this.props.forms && (
          <div className="text-center">
            <p>There are no forms available for the user.</p>
          </div>
        )}

        {this.props.forms && (
          <div className="row">
            {this.state.mode == 'assign' && (
              <AddForm
                forms={this.props.forms}
                id={this.props.id}
                onFormAssigned={form =>
                {
                  if (form.form == '2' || form.form == '3')
                  {
                    this.setState({ employment: !form.employer, form });
                  }
                  this.props.onFormAssigned(form);
                }}
                account={this.props.account}
                onCancel={() => this.setState({ mode: '' })}
                myStudentData={this.props.myStudentData}
              />
            )}
            <div className="col-12">
              <Paper>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Form</TableCell>
                      <TableCell>Servicer</TableCell>
                      <TableCell>Status</TableCell>
                      <TableCell>Options</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableHead>
                    <TableRow>
                      <TableCell className="text-center" colSpan={4}>
                        Standard Forms
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {this.renderFormsGroup(
                      this.props.forms.filter(
                        form =>
                          !form.live &&
                          AnalysisTools.canSubmit(form) &&
                          /^[0-9]+$/.test(form.form)
                      )
                    )}
                  </TableBody>
                  <TableHead>
                    <TableRow>
                      <TableCell className="text-center" colSpan={4}>
                        Standard Attachments
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {this.renderFormsGroup(
                      this.props.forms.filter(
                        form =>
                          !form.completed &&
                          !AnalysisTools.canSubmit(form) &&
                          /^[0-9]+$/.test(form.form)
                      )
                    )}
                  </TableBody>
                  <TableHead>
                    <TableRow>
                      <TableCell className="text-center" colSpan={4}>
                        Other Forms
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {this.renderFormsGroup(
                      this.props.forms.filter(
                        form =>
                          ((form.type !== 'document' && !form.live) ||
                            (form.type === 'document' && !form.completed)) &&
                          !/^[0-9]+$/.test(form.form)
                      )
                    )}
                  </TableBody>
                </Table>
              </Paper>
            </div>
            <div className="line-break" />
            <div className="line-break" />
            {this.props.account.status == 'forms' &&
              Auth.account.role != 'sales' &&
              AnalysisTools.strategyRecommendsSameIDR(this.props.account) &&
              this.props.account.forms.find(f => f.form == 0) && (
                <div className="col-12">
                  <div className="alert alert-warning">
                    The strategy for this user is recommending the same Income
                    Driven Repayment Plan for some of the loans of the user. You
                    are going to assign the{' '}
                    <b>Income Driven Repayment Plan Request form</b> to the
                    user, which will mean the user will re-certify his/her IDR
                    plans and{' '}
                    <b>
                      may imply a higher monthly payment for some of the loans
                    </b>
                    .
                  </div>
                </div>
              )}

            <div style={{ display: 'flex', gap: '16px', width: '100%', justifyContent: 'center' }}>
              {this.canFormsBeAssignedToUser() && (
                <Tooltip title="Assign new Form to the User" placement="top">
                  <button
                    onClick={() => this.setState({ mode: 'assign' })}
                    className="btn btn-secondary"
                  >
                    Assign required form
                  </button>
                </Tooltip>
              )}
              {this.canUserBeActivated() && (
                <button
                  onClick={() => this.authorize()}
                  className="btn btn-primary loading"
                  disabled={this.state.approving}
                >
                  Approve required forms
                </button>
              )}
            </div>

            <div className="col-12">
              <h4 className="text-left">Forms Submitted to Servicer</h4>
              <div className="line-break" />
              <Paper>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Form</TableCell>
                      <TableCell>Servicer</TableCell>
                      <TableCell>Date Submitted</TableCell>
                      <TableCell>Options</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {this.props.forms.filter(
                      form => form.live && AnalysisTools.canSubmit(form)
                    ).length === 0 && (
                        <TableRow>
                          <TableCell colSpan={4} className="text-center">
                            No forms have been submitted to the servicer.
                          </TableCell>
                        </TableRow>
                      )}
                    {this.props.forms
                      .filter(
                        form => form.live && AnalysisTools.canSubmit(form)
                      )
                      .map((form, index) => (
                        <TableRow>
                          <TableCell>{this.renderFormName(form)}</TableCell>
                          <TableCell>
                            {[0, 1].includes(Number(form.form)) || (!AnalysisTools.hasDefaultServicer(form.form) &&
                              form.servicer)
                              ? Formatter.getServicerFromId(
                                form.servicer,
                                this.props.myStudentData,
                                this.props.servicers
                              )
                              : Formatter.getDefaultServicerForForm(form.form)}
                          </TableCell>
                          <TableCell>
                            {moment(form.date_submited, 'X').format('MM/DD/YYYY')}
                          </TableCell>
                          <TableCell>
                            {this.props.account.membership > 0 &&
                              !form.live && (
                                <IconButtonFileUploader
                                  accept=".pdf"
                                  onError={this.props.showError}
                                  name="file"
                                  disabled={
                                    this.state.uploadingSignedForm &&
                                    this.state.uploadingSignedForm.form ==
                                    form.form &&
                                    this.state.uploadingSignedForm.servicer ==
                                    form.servicer
                                  }
                                  onUpload={formData =>
                                  {
                                    return new Promise((resolve, reject) =>
                                    {
                                      this.setState({
                                        uploadingSignedForm: form
                                      });
                                      FormsApi.uploadSignedForm(
                                        this.props.id,
                                        form.id,
                                        formData
                                      )
                                        .then(
                                          success =>
                                          {
                                            this.setState({
                                              uploadingSignedForm: null
                                            });
                                            this.props.onFormCompleted(
                                              form,
                                              form.servicer
                                            );
                                            this.props.showMessage(
                                              'The form has been uploaded successfully.'
                                            );
                                            resolve(true);
                                          },
                                          error =>
                                          {
                                            this.setState({
                                              uploadingSignedForm: null
                                            });
                                            reject(error);
                                          }
                                        )
                                        .catch(error =>
                                        {
                                          this.setState({
                                            uploadingSignedForm: null
                                          });
                                          reject(error);
                                        });
                                    });
                                  }}
                                  label="Upload Filled Form"
                                >
                                  <AttachFile />
                                </IconButtonFileUploader>
                              )}
                            {this.formStatusButtonAction(form)}
                            {this.isFormApprovedOrRejected(form, 'approved') && (
                              <Chip
                                label={`Approved on ${moment(
                                  form.date_approved_or_rejected || moment().format('X'),
                                  'X'
                                ).format('MM/DD/YYYY')}`}
                              />
                            )}
                            {this.isFormApprovedOrRejected(form, 'rejected') && (
                              <Chip
                                label={`Rejected on ${moment(
                                  form.date_approved_or_rejected || moment().format('X'),
                                  'X'
                                ).format('MM/DD/YYYY')}`}
                              />
                            )}
                            {this.props.account.membership > 0 &&
                              form.submitted &&
                              form.live &&
                              form.faxGUID &&
                              form.faxStatusCode &&
                              form.faxStatusCode === 'P' &&
                              !form.status && <Chip label="Fax Pending" />}
                            {this.props.account.membership > 0 &&
                              form.submitted &&
                              form.live &&
                              form.faxGUID &&
                              form.faxStatusCode &&
                              form.faxStatusCode === 'S' &&
                              !form.status && (
                                <Chip label="Fax Sent" color="primary" />
                              )}
                            {this.props.account.membership > 0 &&
                              form.submitted &&
                              form.live &&
                              form.faxGUID &&
                              form.faxStatusCode &&
                              form.faxStatusCode === 'T' &&
                              !form.status && <Chip label="Fax Transmitting" />}
                            {this.props.account.membership > 0 &&
                              form.submitted &&
                              form.live &&
                              form.faxGUID &&
                              form.faxStatusCode &&
                              form.faxStatusCode === 'E' &&
                              !form.status && (
                                <Chip label="Fax Error" color="secondary" />
                              )}
                            {this.props.account.membership > 0 &&
                              form.submitted &&
                              form.live &&
                              form.faxGUID &&
                              form.faxStatusCode &&
                              form.faxStatusCode === 'H' &&
                              !form.status && <Chip label="Fax On Hold" />}

                            {this.props.account.membership > 0 &&
                              form.submitted &&
                              form.live &&
                              form.faxGUID &&
                              form.faxStatusCode &&
                              !form.status &&
                              (form.faxStatusCode === 'P' ||
                                form.faxStatusCode === 'H' ||
                                form.faxStatusCode === 'E') && (
                                <Tooltip title="Resend Fax">
                                  <IconButton
                                    disabled={
                                      this.state.updating &&
                                      this.state.form.id === form.id
                                    }
                                    onClick={() =>
                                      this.setState(
                                        { form },
                                        this.submitFormFax
                                      )
                                    }
                                  >
                                    {(!this.state.updating ||
                                      !this.state.form.id !== form.id) && (
                                        <SettingsBackRestore />
                                      )}
                                  </IconButton>
                                </Tooltip>
                              )}
                            {form.completed && (
                              <>
                                <Tooltip title="Download Filled Form">
                                  <IconButton
                                    disabled={
                                      this.state.downloadingSignedForm &&
                                      this.state.downloadingSignedForm.form ==
                                      form.form &&
                                      this.state.downloadingSignedForm
                                        .servicer == form.servicer
                                    }
                                    onClick={() =>
                                      this.setState(
                                        { downloadingSignedForm: form },
                                        () =>
                                          FormsApi.downloadSignedForm(
                                            this.props.id,
                                            form.id,
                                            form.form,
                                            true,
                                            form.file
                                          )
                                            .then(
                                              success =>
                                                this.setState({
                                                  downloadingSignedForm: null
                                                }),
                                              error =>
                                                this.setState(
                                                  {
                                                    downloadingSignedForm: null
                                                  },
                                                  this.props.showError
                                                )
                                            )
                                            .catch(error =>
                                              this.setState(
                                                {
                                                  downloadingSignedForm: null
                                                },
                                                this.props.showError
                                              )
                                            )
                                      )
                                    }
                                  >
                                    {(!this.state.downloadingSignedForm ||
                                      !this.state.downloadingSignedForm
                                        .form == form.form ||
                                      !this.state.downloadingSignedForm
                                        .servicer == form.servicer) && (
                                        <CloudDownload />
                                      )}
                                    {this.state.downloadingSignedForm &&
                                      this.state.downloadingSignedForm.form ==
                                      form.form &&
                                      this.state.downloadingSignedForm
                                        .servicer == form.servicer && (
                                        <CircularProgress size={20} />
                                      )}
                                  </IconButton>
                                </Tooltip>
                                <Tooltip title="Preview Form">
                                  <IconButton
                                    onClick={() =>
                                      this.setState({
                                        previewForm: {
                                          formId: form.id,
                                          form: form.form,
                                          fileName: form.file
                                        }
                                      })
                                    }
                                  >
                                    <Preview />
                                  </IconButton>
                                </Tooltip>
                              </>
                            )}

                            {this.props.account.membership != -1 && (
                              <Tooltip title="Delete Required Form">
                                <IconButton
                                  disabled={
                                    this.state.deleting &&
                                    this.state.deleting.form == form.form &&
                                    this.state.deleting.servicer ==
                                    form.servicer
                                  }
                                  onClick={() => this.delete(form)}
                                >
                                  {(!this.state.deleting ||
                                    !this.state.deleting.form == form.form ||
                                    !this.state.deleting.servicer ==
                                    form.servicer) && <Delete />}
                                  {this.state.deleting &&
                                    this.state.deleting.form == form.form &&
                                    this.state.deleting.servicer ==
                                    form.servicer && (
                                      <CircularProgress size={20} />
                                    )}
                                </IconButton>
                              </Tooltip>
                            )}
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </Paper>
            </div>
            <div className="line-break" />
            <div className="col-12">
              <h4 className="text-left">Additional Documentation Provided</h4>
              <div className="line-break" />
              <Paper>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Document Name</TableCell>
                      <TableCell>Date Assigned</TableCell>
                      <TableCell>Options</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {(!this.props.account.forms || this.props.account.forms.filter(
                      form => form.completed && !AnalysisTools.canSubmit(form)
                    ).length === 0) && (
                        <TableRow>
                          <TableCell colSpan={3} className="text-center">
                            No additional documentation provided.
                          </TableCell>
                        </TableRow>
                      )}
                    {this.props.account.forms && this.props.account.forms
                      .filter(
                        form => form.completed && !AnalysisTools.canSubmit(form)
                      )
                      .map((form, index) => (
                        <TableRow key={`additional-form-${index}`}>
                          <TableCell>{this.renderFormName(form)}</TableCell>
                          <TableCell>
                            {moment(form.assigned || form.date, 'X').format(
                              'MM/DD/YYYY'
                            )}
                          </TableCell>
                          <TableCell>
                            <Tooltip title="Download Filled Form">
                              <IconButton
                                disabled={
                                  this.state.downloadingSignedForm &&
                                  this.state.downloadingSignedForm.form ==
                                  form.form &&
                                  this.state.downloadingSignedForm.servicer ==
                                  form.servicer
                                }
                                onClick={() =>
                                  this.setState(
                                    { downloadingSignedForm: form },
                                    () =>
                                      FormsApi.downloadSignedForm(
                                        this.props.id,
                                        form.id,
                                        form.form,
                                        true,
                                        form.file,
                                        null,
                                        form.type === 'document' && (form.files ?? []).length > 0
                                      )
                                        .then(
                                          success =>
                                            this.setState({
                                              downloadingSignedForm: null
                                            }),
                                          error =>
                                            this.setState(
                                              {
                                                downloadingSignedForm: null
                                              },
                                              this.props.showError
                                            )
                                        )
                                        .catch(error =>
                                          this.setState(
                                            { downloadingSignedForm: null },
                                            this.props.showError
                                          )
                                        )
                                  )
                                }
                              >
                                {(!this.state.downloadingSignedForm ||
                                  !this.state.downloadingSignedForm.form ==
                                  form.form ||
                                  !this.state.downloadingSignedForm.servicer ==
                                  form.servicer) && <CloudDownload />}
                                {this.state.downloadingSignedForm &&
                                  this.state.downloadingSignedForm.form ==
                                  form.form &&
                                  this.state.downloadingSignedForm.servicer ==
                                  form.servicer && (
                                    <CircularProgress size={20} />
                                  )}
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Preview Form">
                              <IconButton
                                onClick={() => this.determinePreviewModal(form)}
                              >
                                <Preview />
                              </IconButton>
                            </Tooltip>
                            {this.props.account.membership != -1 && (
                              <Tooltip title="Delete Required Form">
                                <IconButton
                                  disabled={
                                    this.state.deleting &&
                                    this.state.deleting.form == form.form &&
                                    this.state.deleting.servicer ==
                                    form.servicer
                                  }
                                  onClick={() => this.delete(form)}
                                >
                                  {(!this.state.deleting ||
                                    !this.state.deleting.form == form.form ||
                                    !this.state.deleting.servicer ==
                                    form.servicer) && <Delete />}
                                  {this.state.deleting &&
                                    this.state.deleting.form == form.form &&
                                    this.state.deleting.servicer ==
                                    form.servicer && (
                                      <CircularProgress size={20} />
                                    )}
                                </IconButton>
                              </Tooltip>
                            )}
                            {form.form === "5ea6da777f41977661959e9c" &&
                              (<Tooltip title="Edit Form">
                                <IconButton
                                  onClick={() =>
                                    this.setState({
                                      editForm: {
                                        formId: form.id,
                                        documentName: this.getCustomFormName(form),
                                        notes: form.notes,
                                        userId: this.props.account._id
                                      }
                                    })
                                  }
                                >
                                  <Edit />
                                </IconButton>
                              </Tooltip>
                              )}
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </Paper>
            </div>
            <div className="line-break" />
            <div
              className={`${this.props.account.status == 'forms' &&
                Auth.account.role != 'sales'
                ? 'col-6 text-right'
                : 'col-12 text-center'
                }`}
            >
              {this.props.account.voidedForms &&
                this.props.account.voidedForms.length > 0 && (
                  <div className="row">
                    <div className="col-12">
                      <div className="line-break" />
                      <h4 className="text-left">Voided Forms</h4>

                      <Paper>
                        <Table>
                          <TableHead>
                            <TableRow>
                              <TableCell>Form</TableCell>
                              <TableCell>Servicer</TableCell>
                              <TableCell>Name</TableCell>
                              <TableCell>Date Voided</TableCell>
                              <TableCell>Reason</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {this.props.account.voidedForms.map(
                              (form, index) => (
                                <TableRow key={`voided-form-${index}`}>
                                  <TableCell>
                                    {this.renderFormName(form)}
                                  </TableCell>
                                  <TableCell>
                                    {!AnalysisTools.hasDefaultServicer(
                                      form.form
                                    ) && form.servicer
                                      ? Formatter.getServicerFromId(
                                        form.servicer,
                                        this.props.myStudentData,
                                        this.props.servicers
                                      )
                                      : Formatter.getDefaultServicerForForm(
                                        form.form
                                      )}
                                  </TableCell>
                                  <TableCell>{form.voided_by}</TableCell>
                                  <TableCell>
                                    {moment(form.date_voided, 'X').format(
                                      'MM/DD/YYYY'
                                    )}
                                  </TableCell>
                                  <TableCell>{form.reason}</TableCell>
                                </TableRow>
                              )
                            )}
                          </TableBody>
                        </Table>
                      </Paper>
                    </div>
                  </div>
                )}
            </div>

            <div className="col-12">
              <div className="line-break" />
              <h4 className="text-left">User MMP details for SLRA</h4>
              <div className="line-break" />
              <Paper>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>MMP Amount</TableCell>
                      <TableCell>Type</TableCell>
                      <TableCell>Date of Changes</TableCell>
                      <TableCell>Proof</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {(!this.props.account.contributionLoans || this.props.account.contributionLoans.length === 0) && (
                      <TableRow>
                        <TableCell colSpan={4} className="text-center">
                          No user MMP details for SLRA
                        </TableCell>
                      </TableRow>
                    )}
                    {(this.props.account.contributionLoans ?? [])
                      .map((item, index) => (
                        <TableRow key={`mmp-proof-${index}`}>
                          <TableCell>${Formatter.money(item.mmpAmount)}</TableCell>
                          <TableCell>{item.type}</TableCell>
                          <TableCell>
                            {moment(item.date).format('MM/DD/YYYY')}
                          </TableCell>
                          <TableCell>
                            {item.proof ? (
                              <Tooltip title="Preview Proof">
                                <IconButton
                                  onClick={() => this.setState({ loanProof: item.proof })}
                                >
                                  <Preview />
                                </IconButton>
                              </Tooltip>
                            ) : (<span>No Proof</span>)}
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </Paper>
            </div>
            <div className="line-break" />

          </div>
        )}
        <div className="line-break" />
        {this.state.employment && (
          <PSLFDestinatary
            onCancel={() => this.setState({ employment: false })}
            onConfirm={async (notes, employer) =>
            {
              this.setState({ employer, employment: false });
              try
              {
                const payload = { 'employer': employer, 'notes': notes };
                await FormsApi.updateForm(this.props.id, this.state.form.id, payload)
                this.props.showMessage('Employer successfully assigned to the form.');
                this.props.onEmployer(this.state.form.id, employer);
              } catch (error)
              {
                this.props.showError(error)
              }
            }}
            employer={this.props.account.employer}
            note={(this.state.form || {}).notes}
            domainId={this.props.account.domain}
          />
        )}
        {this.state.void && (
          <VoidFormReason
            onCancel={() => this.setState({ void: false, form: null })}
            onConfirm={reason => this._proceedToDelete(this.state.form, reason)}
          />
        )}

        <Menu
          id={`form-menu`}
          anchorEl={this.state.faxAnchorEl}
          keepMounted
          open={this.state.faxAnchorEl ? true : false}
          onClose={() => this.closeFaxFormMenu()}
        >
          <MenuItem onClick={this.submitFormFax}>Fax Form</MenuItem>
          <MenuItem onClick={this.markFaxForm}>Mark as Submitted</MenuItem>
        </Menu>

        {this.state.showFormActionModal && (
          <ApproveFormModal
            isUpdating={this.state.updating}
            onApprove={this.update}
            form={this.state.form}
            status={this.state.formActionStatus}
            onCancel={() =>
              this.setState({ showFormActionModal: false, formActionStatus: '' })
            }
            employer={this.props.account.employer}
          />
        )}
      </div>
    ) : (
      <div className="col-12 padding">
        <p className="text-center">
          This view is not available to this user because he/she has private loan
        </p>
      </div>
    );
  }
}
const mapStateToProps = state =>
{
  return {
    servicers: state.data.servicers,
    customForms: state.data.forms
  };
};
export default connect(mapStateToProps, {
  showError,
  showMessage,
  confirmAction,
  updateServicer
})(Forms);
